export enum PermissionMode {
  Permission = 0,
  Approval = 1,
  PassingOn = 2,
  Denial = 3,
  RequestingNewOffer = 4,
  ReturnRequester = 5,
}
